<div *ngIf="warning" class="st-backdrop" role="presentation">
  <div class="st-card" role="alertdialog" aria-modal="true" aria-labelledby="st-title" aria-describedby="st-body" data-test="session-timeout-dialog">
    <div class="st-brand">
      <img src="assets/images/logo.png" alt="" class="st-logo" />
      <span class="st-product">MedPal Admin</span>
    </div>
    <h2 id="st-title" class="st-title">Still there?</h2>
    <p id="st-body" class="st-body">
      You've been idle for a while. To protect patient and provider data, this session ends in
      <strong class="st-countdown" data-test="countdown">{{ countdown }}</strong>.
    </p>
    <p *ngIf="error" class="st-error" role="alert" data-test="error">Couldn't reach the server. Check your connection and try again.</p>
    <div class="st-actions">
      <button #stayBtn type="button" class="btn btn-primary st-stay" (click)="stay()" [disabled]="busy" data-test="stay">
        {{ busy ? 'One moment…' : 'Stay signed in' }}
      </button>
      <button type="button" class="btn btn-link st-leave" (click)="signOut()" [disabled]="busy" data-test="sign-out">
        Sign out now
      </button>
    </div>
  </div>
</div>
